import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import AllOrdersLayer from "../../components/orders/AllOrdersLayer";

const AllOrdersPage = () => {
    return (
        <MasterLayout>
            <AllOrdersLayer />
        </MasterLayout>
    );
};

export default AllOrdersPage;
